import { Injectable, signal } from '@angular/core';

interface BreadcrumbOverride {
  url: string;
  labels: string[];
}

// El breadcrumb del header se arma solo desde el menú del backend (ver
// nav-items.ts), que no conoce pantallas de detalle (ej. "Usuarios de un rol
// puntual") ni datos que la propia página recién carga (ej. el nombre del
// rol). Una página así registra acá los segmentos extra para su URL exacta;
// el header los agrega después de la cadena que ya arma sola. Se "vence"
// solo: si la URL actual no coincide, el header lo ignora sin necesidad de
// que la página lo limpie al destruirse.
@Injectable({ providedIn: 'root' })
export class BreadcrumbExtraService {
  readonly override = signal<BreadcrumbOverride | null>(null);

  set(url: string, labels: string[]): void {
    this.override.set({ url, labels });
  }
}
